"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "germignaga": {
    "8c9f657e": [{
      "hkey": "43037faa",
      "slug": "germignaga",
      "name": "Germignaga",
      "primary": true,
      "skipSearch": false
    }],
    "casa-moro": [{
      "hkey": "43037faa",
      "slug": "germignaga",
      "name": "Germignaga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3907091c": [{
      "hkey": "43037faa",
      "slug": "germignaga",
      "name": "Germignaga",
      "primary": true,
      "skipSearch": false
    }],
    "fornace": [{
      "hkey": "43037faa",
      "slug": "germignaga",
      "name": "Germignaga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "93d8814e": [{
      "hkey": "43037faa",
      "slug": "germignaga",
      "name": "Germignaga",
      "primary": true,
      "skipSearch": false
    }],
    "ronchetto": [{
      "hkey": "43037faa",
      "slug": "germignaga",
      "name": "Germignaga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "02bdc09a": [{
      "hkey": "43037faa",
      "slug": "germignaga",
      "name": "Germignaga",
      "primary": true,
      "skipSearch": false
    }],
    "ronchi": [{
      "hkey": "43037faa",
      "slug": "germignaga",
      "name": "Germignaga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;